import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {PluginModel} from '../../../../../models/api/pluginModel';
import {FrameCard, FrameCardProps} from './frameCard';
import {FrameCardCategory} from './frameCardCategory';
import {FrameCardName} from './frameCardName';
import {FrameCardPin, FrameCardPinProps} from './frameCardPin';
import {PluginFrameCardAvatar} from './pluginFrameCardAvatar';

/*
 * Props.
 */

interface PluginFrameCardProps extends FrameCardProps, FrameCardPinProps {
  plugin: PluginModel;
}

/*
 * Component.
 */

export const PluginFrameCard: FC<PluginFrameCardProps> = ({plugin, ...props}) => (
  <FrameCard {...props} isEnabled>
    <PluginFrameCardAvatar pluginName={plugin.name} pluginColor={plugin.color} />
    <FrameCardName>{plugin.name}</FrameCardName>
    <FrameCardCategory>
      <Trans id="sidepanel-plugin">Plugin</Trans>
    </FrameCardCategory>
    <FrameCardPin {...props} />
  </FrameCard>
);
